module.exports = __webpack_public_path__ + "static/media/app-image-with-text.19fa81cf.png";